<mat-paginator (page)="onPageChanged($event)" [length]="ttTotalCount" [pageSize]="ttPageSize" [pageSizeOptions]="[5, 10, 25, 100]"> </mat-paginator>
